/// <amd-module name="Test/TestPlansHubRefresh/TestCaseResultsPanel/Redux/TestCaseResultsPanelModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { TestCaseResultsPanelActions } from "./TestCaseResultsPanelActions";
import { IResultsPanelAwareState } from "./TestCaseResultsPanelContracts";
import { TestCaseResultsPanelReducer } from "./TestCaseResultsPanelReducer";
import { TestCaseResultsPanelSaga } from "./TestCaseResultsPanelSaga";

export function getResultsPanelModule(testCaseId: number): ISagaModule<IResultsPanelAwareState> {
    const initialActions: ActionsUnion<typeof TestCaseResultsPanelActions>[] = [];
    initialActions.push(TestCaseResultsPanelActions.fetchTestCaseResults(testCaseId));
    return {
        id: "resultspanel",
        reducerMap: {
            resultsPanelState: TestCaseResultsPanelReducer
        },
        sagas: [TestCaseResultsPanelSaga],
        initialActions: initialActions
    };
}
